import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";

export function PageHero({ label, title, intro = [], image, compact = false, titleOnImage = false }) {
  const LabelTag = titleOnImage ? "h1" : "p";
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start start", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["0%", "25%"]);
  const scale = useTransform(scrollYProgress, [0, 1], [1, 1.12]);
  return (
    <>
      <section ref={ref} data-testid="page-hero" aria-label={image ? label : undefined} aria-hidden={image && label ? undefined : true} className={`relative overflow-hidden bg-black ${image ? (compact ? "min-h-[56vh]" : "min-h-[70vh]") : "h-[68px]"} flex items-end`}>
        {image && (
          <motion.div style={{ y, scale }} className="absolute inset-0">
            <img src={image} alt="" data-testid="page-hero-image" className="h-full w-full object-cover" />
          </motion.div>
        )}
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-black/30" />
        {image && label && (
          <div className="container-x relative z-10 pt-28 pb-10 md:pb-14">
            <p data-testid="page-hero-label" className="font-head max-w-4xl break-words text-2xl sm:text-3xl font-medium leading-tight tracking-tight text-white">{label}</p>
          </div>
        )}
      </section>
      {(title || intro.length > 0) && (
      <section className="bg-white border-b border-[var(--line)]" data-testid="page-intro" aria-labelledby={title ? "page-heading" : undefined}>
        <div className="container-x pt-12 pb-8 md:pt-16 md:pb-10 grid grid-cols-12 gap-6">
          <div className="col-span-12 lg:col-span-8">
            {title && <h1 id="page-heading" data-testid="page-heading" className="h-display text-4xl sm:text-5xl lg:text-6xl text-black">{title}</h1>}
            {intro.length > 0 && (
              <div className={`${title ? "mt-6 " : ""}space-y-5`}>
                {intro.map((p, i) => (
                  <p key={i} className="text-sm md:text-[15px] leading-relaxed text-[var(--ink-2)]" data-testid={`page-intro-${i}`}>{p}</p>
                ))}
              </div>
            )}
          </div>
        </div>
      </section>
      )}
    </>
  );
}
